import Link from "@/components/ui/CcLink";

type CcAnimatedLinkProps = {
  href: string;
  children: string;
  /** Exchanges a right arrow for a left arrow on hover. */
  arrow?: boolean;
  className?: string;
};

function CcAnimatedLinkArrow() {
  return (
    <svg className="cc-animated-link__arrow" viewBox="0 0 20 15" aria-hidden="true">
      <path
        d="M1 7.5h18M12.7 1l6.3 6.5-6.3 6.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

/**
 * Text CTA based on arrowlinkcta.framer.website.
 * The underline changes direction on hover; `arrow` also swaps the arrow across the label.
 */
export function CcAnimatedLink({
  href,
  children,
  arrow = false,
  className,
}: CcAnimatedLinkProps) {
  return (
    <Link
      href={href}
      className={[
        "cc-animated-link",
        arrow ? "cc-animated-link--arrow" : "cc-animated-link--plain",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="cc-animated-link__content">
        {arrow ? (
          <span className="cc-animated-link__arrow-slot cc-animated-link__arrow-slot--leading" aria-hidden="true">
            <CcAnimatedLinkArrow />
          </span>
        ) : null}
        <span className="cc-animated-link__label">{children}</span>
        {arrow ? (
          <span className="cc-animated-link__arrow-slot cc-animated-link__arrow-slot--trailing" aria-hidden="true">
            <CcAnimatedLinkArrow />
          </span>
        ) : null}
      </span>
      <span className="cc-animated-link__underline" aria-hidden="true">
        <span className="cc-animated-link__line cc-animated-link__line--incoming" />
        <span className="cc-animated-link__line cc-animated-link__line--outgoing" />
      </span>
    </Link>
  );
}
